export const ALL_PROCEDURES_ID = 0;
export const PROCEDURES_IN_GROUP_ID = 2;

export const PROCEDURES_AVAILABILITY_ALL = 0;
export const PROCEDURES_PRIVATE = 1;
export const PROCEDURES_IN_PUBLIC = 2;
export const PROCEDURES_NOT_ASSIGNED = 3;
